import * as React from "react";
import { createContext, Dispatch, FC, SetStateAction, useContext, useState } from "react";

export interface IFormat {
    label: string;
    value: string;
}

export const pageOrientation = [
    {
        label: "A3 Landscape",
        value: "A3 landscape"
    },
    {
        label: "A3 Portrait",
        value: "A3 portrait"
    },
    {
        label: "A4 Landscape",
        value: "A4 landscape"
    },
    {
        label: "A4 Portrait",
        value: "A4 portrait"
    }
];

export interface IPrintContext {
    loading: boolean;
    setLoading: Dispatch<SetStateAction<boolean>>;
    useLegend: boolean;
    setUseLegend: Dispatch<SetStateAction<boolean>>;
    useVectors: boolean;
    setUseVectors: Dispatch<SetStateAction<boolean>>;
    printUrl: string;
    setPrintUrl: Dispatch<SetStateAction<string>>;
    format: IFormat;
    setFormat: Dispatch<SetStateAction<IFormat>>;
}

const PrintContext = createContext<IPrintContext>(null);

export const usePrintContext = (): IPrintContext => useContext(PrintContext);

export const PrintContextProvider: FC = (props: React.PropsWithChildren<IPrintContext>) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [useLegend, setUseLegend] = useState<boolean>(false);
    const [useVectors, setUseVectors] = useState<boolean>(false);
    const [printUrl, setPrintUrl] = useState<string>("");
    const [format, setFormat] = useState<IFormat>(pageOrientation[2]);

    const values = {
        loading,
        setLoading,
        useLegend,
        setUseLegend,
        useVectors,
        setUseVectors,
        printUrl,
        setPrintUrl,
        format,
        setFormat
    };

    return <PrintContext.Provider value={values}>{props.children}</PrintContext.Provider>;
};
